import { useDeployUiStore } from '../stores/deployUiStore';

import i18n from '~/common/helpers/i18n';

export type DeployPayload = {
  actions?: { resetForm?: () => void };
  [key: string]: unknown;
};

export type RuntimeDispatch = {
  configuration: { successItems: (items: unknown[]) => void };
  snackbar: { create: (props: { text: string }) => void };
};

export const formatDeployError = (message: string) =>
  message.replace('GraphQL error:', '');

export function runDeploySuccessEffects(
  dispatch: RuntimeDispatch,
  payload: DeployPayload
) {
  payload?.actions?.resetForm?.();
  useDeployUiStore.getState().closeDeploySheet();
  dispatch.configuration.successItems([]);
  dispatch.snackbar.create({
    text: i18n.t('scenes.runtime.labels.upper_and_capitalize.capitalized', {
      item: `${i18n.t('scenes.runtime.messages.success.item_deployed')}`
    })
  });
}

export function runDeployErrorEffects(
  dispatch: RuntimeDispatch,
  error: unknown
) {
  const message = error instanceof Error ? error.message : String(error);
  dispatch.snackbar.create({ text: formatDeployError(message) });
}
